/**
 * The kit popups that mount as portals (KuikaSelectbox's dropdown, KuikaDropdownMenu's menu —
 * see KuikaPopupContainerContext) and stay in the DOM with a `-hidden` class once closed, plus
 * KuikaMentions' list, which is only in the DOM while it is open.
 *
 * Escape while one of these is open should be absorbed by the popup, not bubble up and close
 * the surface hosting it (KuikaDrawer, KModal) as well. Stopping the key's propagation is not
 * enough for a drawer: Radix listens for Escape on the document in the capture phase, before
 * the field that holds the popup sees the key at all.
 */
export const OPEN_KIT_POPUP_SELECTOR: string =
  ".kuika-selectbox__dropdown:not(.rc-select-dropdown-hidden), .kuika-dropdown__menu:not(.rc-dropdown-hidden), .kuika-mentions__popup";

/** Whether an open kit popup (select dropdown, dropdown menu, mentions list) exists under `root`. */
export const isKitPopupOpen = (root: ParentNode | null | undefined): boolean =>
  root !== null && root !== undefined && root.querySelector(OPEN_KIT_POPUP_SELECTOR) !== null;
